'use client'

import { isEmpty } from 'lodash-es'
import { useRouter } from 'next/navigation'

import { JoinType } from '@/entities/auth'
import { useDialog, useSession } from '@/shared/lib'
import { AlertDialog, Button } from '@/shared/ui'

import { useSignUp } from '../api/sign-up'
import { convertFormValuesToSignUpGuest } from '../model/converter'
import { useSignUpGuestStore } from '../model/guest-sign-up'
import { useSignUpGuestCompleteStore } from '../model/guest-sign-up-complete'

const SUCCESS_DIALOG = 'SUCCESS_DIALOG'

type Props = {
  disabled: boolean
}

export const SignUpGuestButton = ({ disabled }: Props) => {
  const session = useSession()
  const router = useRouter()
  const { isOpen, open, close } = useDialog()

  const actions = useSignUpGuestCompleteStore(state => state.actions)

  const { signUp } = useSignUp({
    joinType: JoinType.GUEST,
    onSuccess: async () => {
      const { verification } = useSignUpGuestStore.getState()

      const { contactNumber, passportImageUrl } = verification

      const isPassportVerified =
        !isEmpty(contactNumber) && !isEmpty(passportImageUrl)

      actions.updateComplete({
        surveyAvailable: true,
        signUpCompleteTime: new Date().toISOString(),
        verificationType: isPassportVerified ? 'passport' : 'phone',
      })

      if (isPassportVerified) {
        open(SUCCESS_DIALOG)

        return
      }

      await session.update()

      router.push(`/sign-up/guest/complete`)
    },
  })

  const handleSignUp = () => {
    const signUpData = convertFormValuesToSignUpGuest()

    if (!signUpData) {
      return
    }

    signUp(signUpData)
  }

  const handleDialogConfirm = async () => {
    close(SUCCESS_DIALOG)

    await session.update()

    router.push(`/sign-up/guest/complete`)
  }

  const closeDialog = () => {
    close(SUCCESS_DIALOG)
  }

  return (
    <>
      <Button disabled={disabled} size="large" fullWidth onClick={handleSignUp}>
        회원가입 완료하기
      </Button>
      <AlertDialog
        isOpen={isOpen(SUCCESS_DIALOG)}
        onOpenChange={closeDialog}
        title="성공적으로 가입하였습니다"
        content={
          '본인 인증 완료 후,\n삼삼엠투의 모든 서비스 이용이 가능합니다.\n여권 심사에는 최대 1일이 소요됩니다.'
        }
        onConfirm={handleDialogConfirm}
        preventOutsideClick
      />
    </>
  )
}
